import { TeachingLoadReportType } from '@bp/planung-graphql-types';
import { Table, TableColumns } from '@bp/ui-components';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';

export type TeachingLoadReportTypesTableType = {
  type: TeachingLoadReportType;
  name: string;
};

type TeachingLoadReportTypesTableProps = {
  data: TeachingLoadReportTypesTableType[];
  onSelect: (type: TeachingLoadReportType, headline: string) => void;
};

export const TeachingLoadReportTypesTable = observer(({ data, onSelect }: TeachingLoadReportTypesTableProps) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  const columns: TableColumns<TeachingLoadReportTypesTableType>[] = [
    {
      header: '',
      id: 'name',
      accessorKey: 'name',
      canExpand: true,
    },
  ];

  return (
    <Table<TeachingLoadReportTypesTableType>
      hideHeader
      data={data}
      columns={columns}
      onRowClick={(e, row) => {
        setSelectedIndex(parseInt(row.id));
        onSelect(row.original.type, row.original.name);
      }}
      showRowHover
      rowSelection={selectedIndex || selectedIndex === 0 ? { [selectedIndex]: true } : undefined}
      showSelected
      customPadding='var(--spacing-6)'
    />
  );
});
